import type { RouteObject } from 'react-router';

import { BASE } from 'common/src/routes/BaseRoutes';

import Page from 'portal/src/layouts/Page';
import CustomDashboardPage from 'portal/src/pages/customDashboards/CustomDashboardPage';

const CustomDashboardRoutes: RouteObject = {
  path: BASE.CUSTOM_DASHBOARDS,
  element: <Page title="Custom Dashboards" />,
  children: [
    { index: true, element: <CustomDashboardPage /> },
    { path: ':id', element: <CustomDashboardPage /> },
  ],
};

export default CustomDashboardRoutes;
